import moment from 'moment'
import { helpers } from 'vuelidate/lib/validators'

const dateAfter = param =>
  { 
    return helpers.withParams(
    { type: 'dateAfter', value: param },
    (value, group) =>
      !value ||
      moment(value).isSameOrAfter(
        group[param] ? moment(group[param]) : moment(param)
      )
  )
}

export default dateAfter
